import { SVGProps } from 'react'

export const MercaiOpusShortIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="35"
      height="34"
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.14844 19.4339L7.26687 10.1474L3.69456 8.5459H11.8754L5.83331 19.4339H2.14844Z"
        fill="#183E44"
      />
      <path
        d="M9.54883 19.4436L14.6739 10.1474L13.7502 8.5459H19.2791L13.237 19.4339L9.54883 19.4436Z"
        fill="#183E44"
      />
      <path
        d="M26.6842 8.5459L25.734 10.1474L20.6023 19.4533L16.9473 19.45L22.0756 10.1474L21.1552 8.5459H26.6842Z"
        fill="#183E44"
      />
      <path
        d="M16.8379 19.4533L17.7848 17.855L22.9164 8.5459L26.5748 8.55234L21.4432 17.855L22.3669 19.4533H16.8379Z"
        fill="#183E44"
      />
    </svg>
  )
}
